export const AREA_NORMAL_COL = 'normal_col'
export const AREA_BIG_COL = 'big_col'
export const ROW_NORMAL_COL = 'span 1'
export const ROW_BIG_COL = 'span 2'
